export type UserType = {
  id: string
  email: string
  givenName: string
  familyName: string
}

export enum UserStatus {
  CONFIRMED = 'CONFIRMED',
  FORCE_CHANGE_PASSWORD = 'FORCE_CHANGE_PASSWORD',
  UNCONFIRMED = 'UNCONFIRMED',
  EXTERNAL_PROVIDER = 'EXTERNAL_PROVIDER',
  UNKNOWN = 'UNKNOWN',
  RESET_REQUIRED = 'RESET_REQUIRED',
}

export interface CreateUserProps {
  email: string
  givenName: string
  familyName: string
}

export interface CreateUserResponseProps {
  Attributes: Array<{
    Name: string
    Value: string
  }>
  Enabled: boolean
  UserCreateDate: string
  UserLastModifiedDate: string
  UserStatus: UserStatus
  Username: string
}
